import React from "react";
export class ErrorBoundary extends React.Component<any, { hasError: boolean, errorMessage: string, errorGuid: string }> {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: "", errorGuid: "" };
    }

    public UNSAFE_componentWillReceiveProps(nextprops) {
        if (this.state.hasError) {
            this.setState({ hasError: false })
        };
    }


    public componentDidCatch(error, info) {
        this.setState({ hasError: true, errorMessage: error.message, errorGuid: kendo.guid() });
    }

    public render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <h4 style={{ color: "red" }}>Error in component configuration: {this.state.errorMessage}</h4>;
        }
        return <React.Fragment key={this.state.errorGuid || null}>{this.props.children}</React.Fragment>
    }
}
